import { render } from "./ColumnChooser.vue?vue&type=template&id=38b38eea&scoped=true"
import script from "./ColumnChooser.vue?vue&type=script&lang=js"
export * from "./ColumnChooser.vue?vue&type=script&lang=js"

import "./ColumnChooser.vue?vue&type=style&index=0&id=38b38eea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b38eea"]])

export default __exports__